<div class="dashboard layout-spacing" data-testid="dashboard">
    <div class="dashboard__header" data-testid="dashboard-header">
        <div class="dashboard__header-left" data-testid="dashboard-header-left">
            <h1>{{ welcomeGreeting() }}</h1>
            <p>This is your N-Compass Dashboard. Have a take a look!</p>
        </div>
    </div>

    <div class="dashboard__contents">
        <div class="dashboard__overview-content">
            <div class="dashboard__overview-left">
                <!-- Stats Row -->
                <div class="dashboard__stats" data-testid="dashboard-stats">
                    @if (isOverviewLoading()) {
                        @for (i of isAdminAccount() ? [1, 2, 3, 4] : [1, 2]; track $index) {
                            <ntv-skeleton width="100%" height="125px" borderRadius="16px" />
                        }
                    } @else {
                        @for (stat of visibleStatsData(); track stat.title; let idx = $index) {
                            <ntv-card variant="elevated" class="ntv-stat-box">
                                <div
                                    class="ntv-stat-box__container"
                                    data-testid="ntv-stat-box-container">
                                    <div
                                        class="ntv-stat-box__header"
                                        data-testid="ntv-stat-box-header">
                                        @if (stat.iconKey) {
                                            <div
                                                class="ntv-stat-box__icon-wrapper"
                                                data-testid="ntv-stat-box-icon-wrapper">
                                                <svg
                                                    class="ntv-stat-box__icon"
                                                    width="20"
                                                    height="20">
                                                    <use
                                                        [attr.href]="
                                                            spritePath + '#' + stat.iconKey
                                                        "></use>
                                                </svg>
                                            </div>
                                        }
                                        <h3 class="ntv-stat-box__title">{{ stat.title }}</h3>
                                    </div>

                                    <div
                                        class="ntv-stat-box__value-section"
                                        data-testid="ntv-stat-box-value-section">
                                        <div
                                            class="ntv-stat-box__value"
                                            data-testid="ntv-stat-box-value">
                                            {{ stat.total }}
                                        </div>
                                        @if (stat.stats && stat.stats.length > 0) {
                                            <div
                                                class="ntv-stat-box__stats-list"
                                                data-testid="ntv-stat-box-stats-list">
                                                @for (item of stat.stats; track item.label) {
                                                    <div
                                                        class="ntv-stat-box__stat-row"
                                                        data-testid="ntv-stat-box-stat-row">
                                                        <span
                                                            class="ntv-stat-box__stat-value"
                                                            data-testid="dashboard-ntv-stat-box-stat-value-span"
                                                            >{{ item.value }}</span
                                                        >
                                                        <span
                                                            class="ntv-stat-box__stat-label"
                                                            data-testid="dashboard-ntv-stat-box-stat-label-span"
                                                            >{{ item.label }}</span
                                                        >
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            </ntv-card>
                        }
                    }
                </div>

                <!-- Raspberry and Contents Row -->
                <div class="dashboard__raspberry-and-contents" data-testid="dashboard-extra-cards">
                    <!-- Card 1: Raspberry Pi Versions -->
                    @if (isLicensesLoading()) {
                        <ntv-card variant="elevated" class="empty-card">
                            <ntv-skeleton width="100%" height="100%" borderRadius="12px" />
                        </ntv-card>
                    } @else {
                        @if (isBrowser && piVersionsData().length > 0) {
                            <ntv-donut-graph
                                [data]="piVersionsData()"
                                [config]="donutConfig()"></ntv-donut-graph>
                        } @else if (!isBrowser) {
                            <div
                                class="extra-card__skeleton"
                                data-testid="dashboard-extra-card-skeleton">
                                <ntv-skeleton width="100%" height="100%" borderRadius="12px" />
                            </div>
                        } @else {
                            <ntv-card
                                [variant]="'elevated'"
                                [rounded]="'xl'"
                                [shadow]="'md'"
                                class="empty-card"
                                data-testid="dashboard-extra-card-empty-div">
                                <app-empty
                                    [title]="'No Raspberry Pi Data Available'"
                                    [animationWidth]="'12rem'"
                                    [animationHeight]="'12rem'" />
                            </ntv-card>
                        }
                    }

                    <!-- Card 2: Uploaded contents -->
                    @if (isUploadedContentsLoading()) {
                        <ntv-card [variant]="'elevated'" [rounded]="'xl'" [shadow]="'md'">
                            <div class="extra-card__container">
                                <div class="ntv-stat-box__header">
                                    <div class="ntv-stat-box__icon-wrapper">
                                        <svg class="ntv-stat-box__icon" width="20" height="20">
                                            <use
                                                [attr.href]="
                                                    spritePath + '#' + icons.mediaLibrary
                                                "></use>
                                        </svg>
                                    </div>
                                    <h3 class="ntv-stat-box__title">Uploaded Content</h3>
                                </div>
                                <div
                                    class="extra-card__list"
                                    data-testid="dashboard-uploaded-content-list-skeleton">
                                    <ol class="extra-card__ordered-list-loading">
                                        @for (i of [1, 2, 3, 4, 5]; track $index) {
                                            <li class="extra-card__list-item">
                                                <ntv-skeleton
                                                    width="100%"
                                                    height="18px"
                                                    borderRadius="6px" />
                                            </li>
                                        }
                                    </ol>
                                </div>
                            </div>
                        </ntv-card>
                    } @else {
                        <ntv-card [variant]="'elevated'" [rounded]="'xl'" [shadow]="'md'">
                            <div class="extra-card__container">
                                <div class="ntv-stat-box__header">
                                    <div class="ntv-stat-box__icon-wrapper">
                                        <svg class="ntv-stat-box__icon" width="20" height="20">
                                            <use
                                                [attr.href]="
                                                    spritePath + '#' + icons.mediaLibrary
                                                "></use>
                                        </svg>
                                    </div>
                                    <h3 class="ntv-stat-box__title">Uploaded Content</h3>
                                </div>

                                @if (uploadedContentItems().length > 0) {
                                    <div
                                        class="extra-card__list"
                                        data-testid="dashboard-uploaded-content-list">
                                        <ol class="extra-card__ordered-list">
                                            @for (
                                                item of uploadedContentItems();
                                                track $index;
                                                let idx = $index
                                            ) {
                                                <li class="extra-card__list-item">
                                                    <span class="extra-card__list-number"
                                                        >{{ idx + 1 }}.</span
                                                    >
                                                    <span
                                                        class="extra-card__list-title"
                                                        [title]="item.title">
                                                        {{ item.title }}
                                                    </span>
                                                    @if (item.createdAtLabel) {
                                                        <span
                                                            class="extra-card__list-date"
                                                            [title]="item.createdAtLabel">
                                                            {{ item.createdAtLabel }}
                                                        </span>
                                                    }
                                                </li>
                                            }
                                        </ol>
                                    </div>
                                } @else {
                                    <div
                                        class="extra-card__empty"
                                        data-testid="dashboard-uploaded-content-empty-div">
                                        <app-empty
                                            [title]="'No Uploaded Content'"
                                            [animationWidth]="'12rem'"
                                            [animationHeight]="'12rem'" />
                                    </div>
                                }
                            </div>
                        </ntv-card>
                    }
                </div>
            </div>

            <!-- Overview Right: Recent Activity -->
            <div class="dashboard__overview-right">
                <ntv-card variant="elevated" class="dashboard__activity">
                    <div class="activity" data-testid="activity">
                        <div class="activity__header" data-testid="activity-header">
                            <div class="activity__title-group" data-testid="activity-title-group">
                                <div
                                    class="activity__icon-container"
                                    data-testid="activity-icon-container">
                                    <svg class="activity__icon" width="20" height="20">
                                        <use [attr.href]="spritePath + '#' + icons.activity"></use>
                                    </svg>
                                </div>
                                <h2 class="activity__title">Recent Activity</h2>
                            </div>
                        </div>

                        <div class="activity__subheader" data-testid="activity-subheader">
                            <span
                                class="activity__subtitle"
                                data-testid="dashboard-activity-subtitle-span">
                                {{ recentActivityWeekRangeLabel() }}
                            </span>
                        </div>

                        @if (isActivityLoading()) {
                            <!-- full skeleton while first page loads -->
                            <ul
                                class="activity__list"
                                data-testid="dashboard-activity-list-skeleton">
                                @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
                                    <li class="activity__item">
                                        <ntv-skeleton
                                            width="20px"
                                            height="20px"
                                            borderRadius="50%" />
                                        <span class="activity__item-body">
                                            <ntv-skeleton
                                                width="60px"
                                                height="12px"
                                                borderRadius="4px" />
                                            <ntv-skeleton
                                                width="140px"
                                                height="12px"
                                                borderRadius="4px" />
                                        </span>
                                        <ntv-skeleton
                                            width="70px"
                                            height="12px"
                                            borderRadius="4px" />
                                    </li>
                                }
                            </ul>
                        } @else if (recentActivityList().length > 0) {
                            <ul
                                #activityListRef
                                class="activity__list"
                                data-testid="dashboard-activity-list-list">
                                @for (
                                    item of recentActivityList();
                                    track item.type + '-' + item.createdAt + '-' + $index
                                ) {
                                    <li
                                        class="activity__item"
                                        data-testid="dashboard-activity-list-item">
                                        <span class="activity__item-icon" aria-hidden="true">
                                            <svg
                                                class="activity__item-icon-svg"
                                                width="16"
                                                height="16">
                                                <use
                                                    [attr.href]="
                                                        spritePath + '#' + icons.user
                                                    "></use>
                                            </svg>
                                        </span>
                                        <span class="activity__item-body">
                                            @if (currentUserName()) {
                                                <span
                                                    class="activity__item-user"
                                                    [title]="currentUserName()"
                                                    >{{ currentUserName() }}</span
                                                >
                                            }
                                            <span class="activity__item-action">{{
                                                item.action
                                            }}</span>
                                            <span
                                                class="activity__item-title"
                                                [title]="item.label"
                                                >{{ item.label }}</span
                                            >
                                        </span>
                                        <span class="activity__item-date" [title]="item.createdAt">
                                            {{ formatDateTime(item.createdAt) }}
                                        </span>
                                    </li>
                                }

                                <!-- Bottom-only loading skeleton — only visible during load more -->
                                @if (isLoadingMoreActivity()) {
                                    @for (i of [1, 2, 3]; track $index) {
                                        <li class="activity__item">
                                            <ntv-skeleton
                                                width="20px"
                                                height="20px"
                                                borderRadius="50%" />
                                            <span class="activity__item-body">
                                                <ntv-skeleton
                                                    width="60px"
                                                    height="12px"
                                                    borderRadius="4px" />
                                                <ntv-skeleton
                                                    width="140px"
                                                    height="12px"
                                                    borderRadius="4px" />
                                            </span>
                                            <ntv-skeleton
                                                width="70px"
                                                height="12px"
                                                borderRadius="4px" />
                                        </li>
                                    }
                                }

                                <!-- Sentinel for infinite scroll IntersectionObserver -->
                                <li
                                    #activitySentinel
                                    class="activity__sentinel"
                                    aria-hidden="true"></li>
                            </ul>
                        } @else {
                            <ul class="activity__list" data-testid="dashboard-activity-list-list">
                                <li class="activity__empty">
                                    <app-empty
                                        [title]="'No Recent Activity'"
                                        [animationWidth]="'12rem'"
                                        [animationHeight]="'12rem'" />
                                </li>
                            </ul>
                        }
                    </div>
                </ntv-card>
            </div>
        </div>

        <!-- Player Stats: 4 Cards with Video and Image Stats -->
        <div class="dashboard__player-stats" data-testid="dashboard-player-stats">
            @if (isOverviewLoading()) {
                @for (i of [1, 2, 3, 4]; track i) {
                    <app-stats-card [isLoading]="true" />
                }
            } @else {
                @for (card of playerStatCards(); track card.title) {
                    <app-stats-card
                        class="player-stats__player-cards"
                        [statsData]="card"
                        [totalPosition]="'top-right'"
                        [hasTotal]="true" />
                }
                @for (card of contentStatCards(); track card.title) {
                    <app-stats-card
                        [statsData]="card"
                        [totalPosition]="'top-right'"
                        [hasTotal]="true" />
                }
            }
        </div>
    </div>
</div>
